import {Fragment, useEffect, useState} from 'react'
import {useParams} from 'react-router-dom'
import Chat from './Chat'
import Sidebar from './SidebarLeft'
import UserProfileSidebar from './UserProfileSidebar'
import classnames from 'classnames'
import {useDispatch, useSelector} from 'react-redux'
import {getChatContactsFromServer, getUserProfileFromServer} from './store/actions'
import {RD} from './store/actionTypes'
import '@styles/base/pages/app-chat.scss'
import '@styles/base/pages/app-chat-list.scss'

const AppChat = () => {
    const dispatch = useDispatch()
    const {id} = useParams()
    const store = useSelector(state => state.chatRd)

    const [user, setUser] = useState({})
    const [sidebar, setSidebar] = useState(false)
    const [userSidebarRight, setUserSidebarRight] = useState(false)
    const [userSidebarLeft, setUserSidebarLeft] = useState(false)

    const handleSidebar = () => setSidebar(!sidebar)
    const handleUserSidebarLeft = () => setUserSidebarLeft(!userSidebarLeft)
    const handleUserSidebarRight = () => setUserSidebarRight(!userSidebarRight)

    const handleOverlayClick = () => {
        setSidebar(false)
        setUserSidebarRight(false)
        setUserSidebarLeft(false)
    }

    const handleUser = obj => setUser(obj)

    const handleTabChange = (tab) => {
        dispatch({type: RD.SET_ACTIVE_CHAT_TAB, tab})
        dispatch(getChatContactsFromServer(tab))
    }

    // On mount: fetch all 3 tabs so lists are ready without needing a tab click
    useEffect(() => {
        dispatch(getUserProfileFromServer())
        dispatch(getChatContactsFromServer('inbox'))
        dispatch(getChatContactsFromServer('sent'))
        dispatch(getChatContactsFromServer('archive'))
    }, [dispatch])

    const activeTab = store.activeTab || 'inbox'

    // Select the correct contacts list for the active tab
    const activeContacts = (() => {
        if (activeTab === 'sent')    return store.sentContacts
        if (activeTab === 'archive') return store.archiveContacts
        return store.inboxContacts
    })()

    return (
        <Fragment>
            <Sidebar
                store={store}
                sidebar={sidebar}
                handleSidebar={handleSidebar}
                userSidebarLeft={userSidebarLeft}
                handleUserSidebarLeft={handleUserSidebarLeft}
                chatRdContacts={activeContacts}
                selectedUserID={id}
                activeTab={activeTab}
                onTabChange={handleTabChange}
            />
            <div className='content-right'>
                <div className='content-wrapper'>
                    <div className='content-body'>
                        <div className={classnames('body-content-overlay', {
                            show: userSidebarRight === true || sidebar === true || userSidebarLeft === true
                        })}>
                            <button onClick={handleOverlayClick} className='btn btn-link p-0'></button>
                        </div>
                        <Chat
                            store={store}
                            activeTab={activeTab}
                            handleUser={handleUser}
                            handleSidebar={handleSidebar}
                            userSidebarLeft={userSidebarLeft}
                            handleUserSidebarRight={handleUserSidebarRight}
                            selectedUserID={id}
                            selectedUserRdChat={store.selectedUserRdChat}
                            selectedRdContactDetail={store.selectedRdContactDetail}
                            currentUser={store.rdUserProfile}
                            onTabChange={handleTabChange}
                        />
                        <UserProfileSidebar
                            user={user}
                            userSidebarRight={userSidebarRight}
                            handleUserSidebarRight={handleUserSidebarRight}
                        />
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default AppChat